// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_FINANCIAMENTO_ST = {
  EmDigitacao: 'FIN_FINANCIAMENTO_ST1',
  Contratado: 'FIN_FINANCIAMENTO_ST2',
  EmAmortizacao: 'FIN_FINANCIAMENTO_ST3',
  Liquidado: 'FIN_FINANCIAMENTO_ST4',
  Cancelado: 'FIN_FINANCIAMENTO_ST5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_FINANCIAMENTO_ST1: 1,
    FIN_FINANCIAMENTO_ST2: 2,
    FIN_FINANCIAMENTO_ST3: 3,
    FIN_FINANCIAMENTO_ST4: 4,
    FIN_FINANCIAMENTO_ST5: 5
  }
}
